import { EuiFieldText } from "@inscopix/ideas-eui";
import { withUserPermission } from "hocs/withUserPermission";
import { withUserPermissionBase } from "hocs/withUserPermissionBase";

/**
 * Enhanced {@link EuiFieldText} that is disabled when the user lacks a
 * required permission.
 *
 * Context independent.
 */
export const FieldTextPermissionedBase = withUserPermissionBase(EuiFieldText);

/**
 * Enhanced {@link EuiFieldText} that is disabled when the user lacks a
 * required permission.
 *
 * Reads permissions from project permissions context.
 */
export const FieldTextPermissioned = withUserPermission(
  FieldTextPermissionedBase,
);
